import { HeaderLabelChipStyle } from '@tableau/catalog-ui-temp';
import { TabStyles } from '@tableau/widgets';
import React from 'react';

import { SiteUrlsProps } from '~src/bootstrap/redux/selectors/SiteUrlsSelectors';
import { LabelWrapper } from '~src/catalog/CatalogLabelsHookHelper';
import { PublishedConnectionDraftBanner } from '~src/publishedConnection/components/PublishedConnectionDraftBanner';
import {
  EditPublishedConnectionEntityAction,
} from '~src/publishedConnection/entityActions/EditPublishedConnectionEntityAction';
import { IPublishedConnectionActions } from '~src/publishedConnection/serverApi/types/IPublishedConnectionActions';
import { isPublishedConnectionTableInfo } from '~src/publishedConnectionTable/resources/PublishedConnectionTables';
import { ItemDescription } from '~src/spacesPlatform/components/header/HeaderItemDescription';
import {
  ModifiedDateMetadata,
  OwnerMetadata,
  PublishedConnectionPolicyMetaData,
  VirtualConnectionExtractStatusMetadata
} from '~src/spacesPlatform/components/header/HeaderMetadataRow';
import {
  ActionsMenuIcon,
  FavoriteToggleWithCountsIcon
} from '~src/spacesPlatform/components/header/HeaderNameRowIcons';
import { ConnectedSpaceHeader } from '~src/spacesPlatform/components/header/SpaceHeader';
import { ISpaceItemDetailInfo } from '~src/spacesPlatform/models/ISpaceItemDetailInfo';
import { cssClass } from '~src/style';
import { TagsMetadata } from '~src/tags/components/header/TagsMetadata';

const draftClass = cssClass('PublishedConnectionSpaceHeader', 'draft', {
  marginBottom: TabStyles.Spacing.MediumSpace
});

export interface PublishedConnectionSpaceHeaderProps extends SiteUrlsProps {
  readonly itemInfo: ISpaceItemDetailInfo<'virtualConnection'>;
  readonly tableExtractStatusLabel?: String;
  readonly availableActions: IPublishedConnectionActions;
  readonly openDetail: () => void;
  readonly addToFavorites: () => void;
  readonly removeFromFavorites: () => void;
  readonly catalogingOnSiteEnabled: boolean;
}

export function PublishedConnectionSpaceHeader(props: PublishedConnectionSpaceHeaderProps): JSX.Element {
  const tagUrl = React.useCallback((tag: string) => props.urls.virtualConnectionsWithTagUrl(tag), [props.urls]);

  const shouldShowDraftBanner = props.itemInfo && props.itemInfo.publishedConnectionDraft;

  return (
    <ConnectedSpaceHeader
      item={props.itemInfo}
      availableActions={{ ...props.availableActions }}
      nameRowIcons={
        <React.Fragment>
          {FavoriteToggleWithCountsIcon({
            item: props.itemInfo,
            addToFavorites: props.addToFavorites,
            removeFromFavorites: props.removeFromFavorites,
          })}
          {ActionsMenuIcon(props.itemInfo)}
        </React.Fragment>
      }
      metadataRow={
        <React.Fragment>
          {OwnerMetadata(props.itemInfo.owner, props.urls)}
          {ModifiedDateMetadata(props.itemInfo.updatedAt)}
          {VirtualConnectionExtractStatusMetadata(props.itemInfo.tables, props.tableExtractStatusLabel)}
          {isPublishedConnectionTableInfo(props.itemInfo) && PublishedConnectionPolicyMetaData(props.itemInfo)}
          <div style={{marginLeft: '24px'}}>
            <LabelWrapper itemInfo={props.itemInfo} isEager={true} kind={'chip'}
              wrapper={(e) =><HeaderLabelChipStyle>{e}</HeaderLabelChipStyle>} />
          </div>
        </React.Fragment>
      }
      spotlightActions={shouldShowDraftBanner ? [] : [EditPublishedConnectionEntityAction]}
      descriptionElement={<ItemDescription item={props.itemInfo}/>}
      bottomElement={
        <React.Fragment>
          { shouldShowDraftBanner &&
            <div className={draftClass}>
                <PublishedConnectionDraftBanner publishedConnectionDraft={props.itemInfo.publishedConnectionDraft}/>
            </div>
          }
            <TagsMetadata itemInfo={ props.itemInfo} tagUrl={ tagUrl } />
        </React.Fragment>
      }
    />
  );
}
